import React from 'react';

export interface BadgeProps {
  variant?: 'frozen' | 'active' | 'pro' | 'free' | 'connected' | 'available' | 'coming-soon';
  children: React.ReactNode;
  className?: string;
}

export function Badge({ variant = 'active', children, className = '' }: BadgeProps) {
  const baseClass = getBaseClass(variant);
  const variantClass = getVariantClass(variant);
  const classes = [baseClass, variantClass, className].filter(Boolean).join(' ');
  const showStatusDot = variant === 'frozen' || variant === 'active';

  return (
    <span className={classes}>
      {showStatusDot && <span className="status-dot" />}
      {children}
    </span>
  );
}

function getBaseClass(variant: BadgeProps['variant']): string {
  switch (variant) {
    case 'frozen':
    case 'active':
      return 'repo-status-badge';
    case 'pro':
    case 'free':
      return 'org-badge';
    case 'connected':
    case 'available':
    case 'coming-soon':
      return 'status-badge';
    default:
      return 'badge';
  }
}

function getVariantClass(variant: BadgeProps['variant']): string {
  return variant || '';
}
